module.exports = __webpack_public_path__ + "img/header-engagementRingsEntwined.ca885e4.webp";